<app-header></app-header>


<section id="sala-prensa-int" class="bg-grey reset-section-pad2">

    <div class="container" data-aos="fade-right" data-aos-duration="1500">

          <div class="row" >
             <div class="col-lg-12 head-tit">
                   <h1 [innerHTML]="article.title"></h1>
                   <h2 [innerHTML]="article.subtitle"></h2>
                  
             </div>   
         </div>

           <div class="row equipo-int-blq">

            <div class="col-lg-12 equipo-int-blq-inner-img">

                <iframe *ngIf="article.videoUrl; else imgBig"
                
                class="iframe-vid-sp" [src]="videoURI" width="920" height="600" title="{{article.videoTitle}}" frameborder="0"></iframe>
                
                <ng-template #imgBig>
                    <img class="img-fluid" [src]="imgBigUrl" alt="{{article.imgBigAlt}}">
                    <div class="int-showcase__footer bg-grey"></div>
                </ng-template>

            </div>   
        
              <div class="col-lg-8 mt-5 equipo-int-blq-inner-text">
                  <p class="fw-bold">
                    <span *ngIf="article.city">{{article.city}}, </span>
                    {{fecha}}
                </p>
                  <h1 class="rco fw-bold" [innerHTML]="article.summary"></h1>
                  <div class="divider"></div>
                   <p [innerHTML]="article.mainText"></p>

                   <p *ngIf="article.source">
                        <strong>Fuente(s): </strong> <a href="{{article.sourceUrl}}" target="_blank" rel="noreferrer noopener">{{article.source}}</a>
                    </p>
                   <p *ngIf="article.source2">
                        <a href="{{article.sourceUrl2}}" target="_blank" rel="noreferrer noopener">{{article.source2}}</a>
                    </p>
                    <p *ngIf="article.source3">
                        <a href="{{article.sourceUrl3}}" target="_blank" rel="noreferrer noopener">{{article.source3}}</a>
                    </p>
                    <p *ngIf="article.masinfo">
                        <strong>Más información: </strong> <a href="{{article.masinfoUrl}}" target="_blank" rel="noreferrer noopener">{{article.masinfo}}</a>
                    </p>
                   <span *ngIf="article.masinfo2">
                        <a href="{{article.masinfo2Url}}" target="_blank" rel="noreferrer noopener">, {{article.masinfo2}}</a>
                    </span>
                    <span *ngIf="article.masinfo3">
                        <a href="{{article.masinfo3Url}}" target="_blank" rel="noreferrer noopener">, {{article.masinfo3}}</a>
                    </span>            
                <span *ngIf="article.imgBottom">
                    
                    <img src="https://{{article.imgBottom}}" alt="{{article.imgBottomAlt}}" width="{{article.imgBottomWidth}}">     
                </span>


               </div> 

         </div>

         <div class="row">

            <div class="col-lg-12 col-md-12 col-sm-12 col-12 prev-next">
<!-- {{this.id_prev}}}
{{this.id_next}}} -->
                <div class="prev-next-blq">
                    <!--activar clase inactiv cuando no haya ningún elemento más adelante o detrás-->
                     <a 
                     [ngClass]="{'inactiv': currentArticle == 1}"
                     [routerLink]="currentArticle > 1 ? ['/sala-de-prensa/', id_prev] : null"
                     ><span>Anterior</span>
                     </a>
                     <a
                     [ngClass]="{'inactiv': !id_next}"
                     [routerLink]="id_next ? ['/sala-de-prensa/', id_next]: null"
                     ><span>Siguiente</span></a>
     
                </div> 


            </div>

         </div>



     </div><!-- fin container-->

</section>



<app-footer-main></app-footer-main>